module.exports = __webpack_public_path__ + "media/common/images/badges/active/mas_stavu-64a99e7da5218b7dae2c0dd4dc75fa25.svg";